<template>
  <div class="postContainer row overflow">
    <div class="container mx-auto w-md-66 w-lg-50 pt-20">

      <h1 v-if="post.show_title" class="postTitle text-left">{{ post.title }}</h1>

      <PostAuthor
        v-if="isNewsroom"
        :name="post.author_name"
        :publishDate="post.published_formatted ? post.published_formatted : ''"
      />

      <div class="postMetaContent flex-between-start" :class="{'border-top': post.show_title}"></div>

      <div v-if="post.image" class="pb-20">
        <a v-if="post.featured_image_link" :href="post.featured_image_link">
          <img :alt="post.title" class="displayImage cover d-block mx-auto" :src="post.image">
        </a>
        <img v-else :alt="post.title" class="displayImage cover d-block mx-auto" :src="post.image">
      </div>

      <!-- TODO PRB-1377 -->
      <!-- <div class="shareWrapper">
        <button class="shareButton btn ">
          <Share height="22px" width="22px" />
        </button>
      </div> -->

      <div class="postContent" v-html="post.content" />
      <AlsoExplore/>
    </div>
    <ReadNext v-if="readNextPosts.length" :posts="readNextPosts" />
  </div>
</template>

<script>
import { baseIsMobile } from '@js/www/marketplaces/mixins';
// TODO PRB-1377
// import { Share } from '@js/web/components/icons';
import PostAuthor from './PostAuthor.vue';
import ReadNext from './ReadNext.vue';
import fitvids from 'fitvids';
import AlsoExplore from './AlsoExplore.vue';

export default {
  name: 'Post',
  components: {
    AlsoExplore,
    PostAuthor,
    ReadNext,
    // Share
  },
  mixins: [ baseIsMobile ],
  props: {
    postEncoded: {
      type: String,
      required: true
    },
    readNextPostsEncoded: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      post: {},
      readNextPosts: []
    };
  },
  computed: {
    isNewsroom() {
      return this.post.type === 'article';
    },
    displayImageAspect() {
      if (this.isXsMobile) {
        return (204 / 304);
      } else {
        return (600 / 1440);
      }
    }
  },
  beforeMount() {
    try {
      this.post = JSON.parse(this.postEncoded);
    } catch (error) {}
    try {
      this.readNextPosts = JSON.parse(this.readNextPostsEncoded);
    } catch (error) {}
  },
  mounted() {
    fitvids('.postContent');
  }
};
</script>

<style lang="scss">
@import '@sass/vue-imports.scss';
@import '@sass/www/pages/_content.scss';

.postContainer {
  font-weight: normal;

  .postTitle {
    margin: 15px 0;
    word-break: break-word;
  }

  .postMetaContent {
    min-height: 20px;
  }
  .postContent {
    padding-bottom: 50px;
    *:not(.btn) {
      background: inherit !important;
      color: #000 !important;
      line-height: 30px;
    }

    a:not(.btn) {
      color: $link-color !important;
      font-weight: 400 !important;
    }
  }

  .shareWrapper {
    .shareButton {
      background: #FFF;
      box-shadow: 0px 6px 50px rgba(202, 205, 207, 0.5);
      border-radius: 4px;
      padding: 0;
      height: 44px;
      width: 48px;
    }
  }
}
</style>
